import "./CaseStudy.scss";
import ScrollAnimationSection from "../../../components/scrollAnimSec/ScrollAnimSec";
import Slider from "react-slick";
import { images } from "../../../utils/images";

import { TfiAngleLeft } from "react-icons/tfi";
import { TfiAngleRight } from "react-icons/tfi";
import { useRef } from "react";
import AudioPlayer from "../../../components/audioPlayer/AudioPlayer";
import intoAudio from "../../../assets/audio/aiCall.mp4";
import WistiaVideo from "../../../components/wistiaVideo/WistiaVideo";

const CaseStudy = () => {
  const caseStudyList = [
    {
      id: 0,
      type: "video",
      content: "dphddigc93",
      title: "SmartDesk Co-Working Spaces",
      useCase: "AI Receptionist",
      challenge:
        "Grill & Greens, a popular farm-to-table restaurant chain with 4 bustling locations, faced a flood of daily calls for table reservations, menu inquiries, and event bookings. Staff often juggled between serving guests and handling calls, resulting in missed bookings, long wait times, and customer dissatisfaction.",
      solution:
        "By integrating AI Automation Suite’s AI Receptionist, Grill & Greens enabled 24/7 intelligent call handling, with instant answers to common questions, live reservation updates, and smart routing for large-event inquiries.",
      result: [
        {
          id: 0,
          count: "70%",
          des: "Drop in call interruptions during peak hours",
        },
      
        {
          id: 2,
          count: "3X",
          des: "Increase in confirmed reservations without staff involvement",
        },
      
      ],
    },

    // {
    //   id: 1,
    //   type: "audio",
    //   content: intoAudio,
    //   title: "Orion Boutique Hotel Chain",
    //   useCase: "AI Concierge",
    //   challenge:
    //     "Orion Hotel’s front desk received constant queries about local attractions, late check-outs, dining recommendations, and booking changes — especially during off-hours when concierge staff weren’t available.",
    //   solution:
    //     "With AI Automation Suite’s AI Concierge, Orion deployed a multilingual, context-aware chatbot across WhatsApp, SMS, and web chat, capable of handling requests, suggesting personalised itineraries, and syncing with their PMS.",
    //   result: [
    //     {
    //       id: 0,
    //       count: "24/7",
    //       des: "Concierge coverage in 3 languages",
    //     },
    //     {
    //       id: 1,
    //       count: "35%",
    //       des: "Increase in upsold services (spa, dining, local tours)",
    //     },
    //     // {
    //     //   id: 2,
    //     //   count: "20%",
    //     //   des: "Boost in guest satisfaction scores across locations",
    //     // },
    //   ],
    // },

    // {
    //   id: 2,
    //   type: "audio",
    //   content: intoAudio,
    //   title: "Wellpoint Medical Centre",
    //   useCase: "AI Answering Machine",
    //   challenge:
    //     "Wellpoint, a multi-location health clinic, faced heavy after-hours call volumes. Patients often called to confirm appointments, check prescriptions, or leave messages — but response delays affected satisfaction and trust.",
    //   solution:
    //     "AI Automation Suite’s AI Answering Machine captured voicemails, transcribed them instantly, and either auto-responded or routed them to the right department with high-priority tagging based on urgency and sentiment.",
    //   result: [
    //     {
    //       id: 0,
    //       count: "100%",
    //       des: "Call capture after hours",
    //     },
    //     {
    //       id: 1,
    //       count: "80%",
    //       des: "Faster response to critical medical queries",
    //     },
    //   ],
    // },
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const slideRef = useRef(null);

  const goNext = () => {
    slideRef.current.slickNext();
  };

  const goPrev = () => {
    slideRef.current.slickPrev();
  };
  return (
    <section className="case_study_sec">
      <div className="content_wrap">
        <ScrollAnimationSection>
          <div className="title">
            <h2 className="text-center">Case Studies</h2>
          </div>
        </ScrollAnimationSection>

        <div className="case_study_slider_sec">
          {/* <Slider ref={slideRef} {...settings}>
            {caseStudyList?.map((data) => {
              return (
                <div className="case_slide_wrap" key={data?.id}>
                  <div className="slide_grid">
                    <div className="text_side">
                      <div className="top">
                        <h5>Case Study</h5>
                        <p>{data?.useCase}</p>
                      </div>
                      <div className="line"></div>
                      <div className="des">
                        <p>
                          <span>Challenge:</span> {data?.challenge}
                        </p>
                        <p className="mt-2">
                          <span>Solution:</span> {data?.solution}
                        </p>
                      </div>
                      <div className="line"></div>
                      <div className="info_grid">
                        {data?.result?.map((ele, k) => {
                          return (
                            <div className="num_info" key={k}>
                              {ele?.count && <h4>{ele?.count}</h4>}
                              <p>{ele?.des}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="img_wrap">
                      {data?.type === "audio" && (
                        <div className="demo_card">
                          <div className="content_card">
                            <div className="profile_info">
                              <div className="profile_wrap">
                                <img
                                  src={images.aiCalling}
                                  alt="Calling Person"
                                />
                              </div>
                              <h4>Listen to a Sample Call</h4>
                              <p>AI Receptionist</p>
                            </div>
                            <div className="audio_wrap">
                              <AudioPlayer audioFile={intoAudio} />
                            </div>
                          </div>
                        </div>
                      )}

                      {data?.type === "video" && (
                        <WistiaVideo vId={data?.content} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider> */}


          {/* <button type="button" className="arrow left" onClick={goPrev}>
            <TfiAngleLeft />
          </button>
          <button type="button" className="arrow right" onClick={goNext}>
            <TfiAngleRight />
          </button> */}



           {caseStudyList?.map((data) => {
              return (
                <div className="case_slide_wrap" key={data?.id}>
                  <div className="slide_grid">
                    <div className="text_side">
                      <div className="top">
                        <h5>Case Study</h5>
                        <p>{data?.useCase}</p>
                      </div>
                      <div className="line"></div>
                      <div className="des">
                        <p>
                          <span>Challenge:</span> {data?.challenge}
                        </p>
                        <p className="mt-2">
                          <span>Solution:</span> {data?.solution}
                        </p>
                      </div>
                      <div className="line"></div>
                      <div className="info_grid">
                        {data?.result?.map((ele, k) => {
                          return (
                            <div className="num_info" key={k}>
                              {ele?.count && <h4>{ele?.count}</h4>}
                              <p>{ele?.des}</p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="img_wrap">
                      {data?.type === "audio" && (
                        <div className="demo_card">
                          <div className="content_card">
                            <div className="profile_info">
                              <div className="profile_wrap">
                                <img
                                  src={images.aiCalling}
                                  alt="Calling Person"
                                />
                              </div>
                              <h4>Listen to a Sample Call</h4>
                              <p>AI Receptionist</p>
                            </div>
                            <div className="audio_wrap">
                              <AudioPlayer audioFile={intoAudio} />
                            </div>
                          </div>
                        </div>
                      )}

                      {data?.type === "video" && (
                        <WistiaVideo vId={data?.content} />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default CaseStudy;
